// @flow
import Immutable from "seamless-immutable";
import themes from "./BuiltInThemes";

export default () => Immutable({
	__record: "WidgetStylesRecord",
	loadCustomImages: {},
	customImagesResults: {},
	palette: themes.default,
	fonts: {
		fontFamily: null,
		links: [],
	},
	frame: {
		background: "rgba(14,47,90,.6)",
	},
});
